import * as React from "react";
import "styled-components/macro";
import { Flex } from "@rebass/grid";
import {
  Text,
} from "@blueprintjs/core";
import { OutputTag } from "src/types/models";;

interface IProps {
  clientId: number;
  output: OutputTag;
}

interface IState {
  isModalOpen: boolean;
  loading: boolean;
}

const bodyRowCSS = {
  borderBottom: "1px solid #E1E8ED",
  height: "70px",
  width: "100%",
};

const tableCellCSS = {
  height: "48px",
  width: "100%",
};

class OutputTagsRow extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isModalOpen: false,
      loading: false,
    };
  }

  public render() {
    const { output } = this.props;

    return (
      <React.Fragment>
        <tr
          style={{
            ...bodyRowCSS,
          }}
        >
          <td>
            <Flex alignItems="center" css={tableCellCSS}>
              <Text>{output.Name}</Text>
            </Flex>
          </td>

          <td>
            <Flex alignItems="center" css={tableCellCSS}>
              <Text>{output.created_by?.Display_Name}</Text>
            </Flex>
          </td>

          <td>
            <Flex alignItems="center" css={tableCellCSS}>
              <Text>{output.created_at ? new Date(output.created_at).toLocaleDateString() : ""}</Text>
            </Flex>
          </td>
        </tr>
      </React.Fragment>
    );
  }
}

export default OutputTagsRow;
